import React = require("react");
import {RestDataLoader} from "../dashboard/widgets/unilever/RestDataLoader";
import "./AccountRecoveryPage.scss";
import {PasswordResetPage} from "./PasswordResetPage";
import {ThemeProvider} from "@vebox/etui-system";
import {veboxDefaultTheme} from "../index";
import {VeBoxLoginCard} from "../components/card/VeBoxLoginCard";
import {VeboxLoginInput} from "../components/card/VeboxLoginInput/VeboxLoginInput";
import {Button} from "@vebox/etui-core";

export interface RecoveryTexts {
    accountAssistanceTitle: string;
    enterTheEmailAssociatedToTheAccount: string;
    changeCredentials: string;
    enterOtpAndNewCredentials: string;
    insertOtp: string;
    insertEmail: string;
    insertUsername: string;
    insertNewPassword: string;
    confirmNewPassword: string;
    passwordChanged: string;
    continueText: string;
    back: string;
    login: string;
    allFieldsMandatory: string;
    passwordsAreDifferent: string;
    passwordNotSecure: string;
    wrongOtpCode: string;
    invalidUsername: string;
}

interface AccountRecoveryPageProps {
    texts: RecoveryTexts;
}

interface AccountRecoveryPageState {
    recoveryCodeSent: boolean;
    email: string;
    error: string;
}

const VeboxHeader: React.FunctionComponent<{}> = () => {
    return (
        <div draggable="false" style={{position: "absolute"}}>
            <img draggable="false" className="logoPayoff" src="/vebox/images/logoBig.png" alt="Logo"/>
        </div>
    );
};

export class AccountRecoveryPage extends React.Component<AccountRecoveryPageProps, AccountRecoveryPageState> {
    constructor(props) {
        super(props);
        this.state = {
            recoveryCodeSent: false,
            email: "",
            error: null,
        };
        this.sendRecoveryCode = this.sendRecoveryCode.bind(this);
        this.updateEmailValue = this.updateEmailValue.bind(this);
        this.reset = this.reset.bind(this);
    }

    public render() {
        const texts = this.props.texts;
        const content = this.state.recoveryCodeSent ?
            (
                <PasswordResetPage
                    email={this.state.email}
                    onBackClick={this.reset}
                    texts={texts}
                />
            ) : this.renderEmailInput();
        return (
            <ThemeProvider theme={veboxDefaultTheme}>
                <div className={"account-recovery-page red-background"}>
                    <VeboxHeader/>
                    <div className={"account-recovery-page--content"}>
                        {content}
                    </div>
                </div>
            </ThemeProvider>
        );
    }

    private reset() {
        this.setState(
            {
                recoveryCodeSent: false,
                error: null,
            },
        );
    }

    private sendRecoveryCode() {
        if (this.state.email == null || this.state.email === "") {
            return;
        }
        const email: any = {};
        email.email = this.state.email;
        this.setState({recoveryCodeSent: true});
        RestDataLoader.postJSON(
            "support/recovery/account",
            email,
            () => {
                this.setState({recoveryCodeSent: true});
            },
            () => {
                return;
            },
        );
    }

    private updateEmailValue(evt) {
        this.setState(
            {
                email: evt.target.value,
            },
        );
    }

    private renderEmailInput() {
        const texts = this.props.texts;
        return (
            <VeBoxLoginCard className={"loginCard"}>
                <VeBoxLoginCard.Header className={"login-card-header"}>
                    <VeBoxLoginCard.Title text={texts.accountAssistanceTitle}/>
                </VeBoxLoginCard.Header>
                <VeBoxLoginCard.Body className={"mainContentDiv"}>
                    <span className={"intro-text"}>
                        {texts.enterTheEmailAssociatedToTheAccount}
                    </span>
                    <div className={"formDiv"}>
                        <VeboxLoginInput
                            type={"text"}
                            className={"loginInputField"}
                            onChange={this.updateEmailValue}
                            value={this.state.email}
                            placeholder={texts.insertEmail}
                        />
                    </div>
                </VeBoxLoginCard.Body>
                <VeBoxLoginCard.Footer className={"change-password-card-footer"} style={{textAlign: "end"}}>
                    <Button
                        variant={"strong"}
                        onClick={this.sendRecoveryCode}
                    >
                        {texts.continueText}
                    </Button>
                </VeBoxLoginCard.Footer>
            </VeBoxLoginCard>
        );
    }
}
